exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?minimize!../../css/google.css"), "");

// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-0157408e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/index/Google.vue
// module id = 66
// module chunks = 0